import { render, staticRenderFns } from "./buffet.vue?vue&type=template&id=2fcfd4a6&"
import script from "./buffet.vue?vue&type=script&lang=js&"
export * from "./buffet.vue?vue&type=script&lang=js&"
import style0 from "./buffet.vue?vue&type=style&index=0&id=2fcfd4a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports